const datasetMetricsActions = {
  FETCH_DATASET_METRICS: 'FETCH_DATASET_METRICS',
  FETCH_DATASET_METRICS_SUCCESS: 'FETCH_DATASET_METRICS_SUCCESS',
  FETCH_DATASET_METRICS_ERROR: 'FETCH_DATASET_METRICS_ERROR',
};

export default datasetMetricsActions;
